// AddNodeButton.jsx

import React, { useState } from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './AddNodeButton.css';

// Icons
import Icon from 'svg/Icon';

// Components
import AddModal from 'components/addmodal/AddModal';
import Button from 'components/button/Button';

/**
 * AddNodeButton
 * 
 * Renders the add component for the sidebar switcher.
 * 
 * @param {function} onTypeSelect - Handler for node type selection from the popup.
 *  
 * @returns {ReactNode} - AddNodeButton.
 */
const AddNodeButton = React.memo(({ onTypeSelect }) => {

    // ----- CONTEXT ----- //

    // Theme Context
    const { theme } = useTheme();

    // ----- STATE ----- //

    // Hover State
    const [hovered, setHovered] = useState(false);

    // Add Modal Open State
    const [addModalOpen, setAddModalOpen] = useState(false);

    // ----- HANDLERS ----- //

    /**
     * Opens the add modal.
     */
    const handleOpenAddModal = () => {
        setAddModalOpen(true);
    };

    /**
     * Closes the add modal.
     */
    const handleCloseAddModal = () => {
        setAddModalOpen(false);
    };

    /**
     * Handles selecting a node type from the add modal.
     *
     * @param {string} typeKey - The selected node type key.
     */
    const handleTypeSelect = (typeKey) => {
        setAddModalOpen(false);
        if (typeof onTypeSelect === 'function') {
            onTypeSelect(typeKey);
        }
    };

    // ----- RENDER ----- //

    return (
        <>
            <div className="sidebar-switcher-add-container">

                <Button
                    iconKey="wand_stars"
                    iconSize={18}
                    height={44}
                    fontSize={14}
                    gap={6}
                    label="New"
                    onClick={handleOpenAddModal}
                    onMouseEnter={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}
                    width="100%"
                />

            </div>

            {/* ADD BUTTON 
            <div
                className="sidebar-switcher-add-container"
                style={{
                    backgroundColor: hovered ? theme.buttonHoverBackgroundColor : theme.buttonBackgroundColor,
                    borderRadius: 7,
                }}
                onClick={handleOpenAddModal}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
            >
                <Icon
                    iconKey="add"
                    color={hovered ? theme.buttonHoverIconColor : theme.foreground}
                    width={24}
                    height={24}
                />
            </div>
            */}

            {/* ADD MODAL */}
            <AddModal
                isOpen={addModalOpen}
                onClose={handleCloseAddModal}
                showFind={false}
                onTypeSelect={handleTypeSelect}
            />
        </>
    );

});

// Dev Tools
AddNodeButton.displayName = 'AddNodeButton';

export default AddNodeButton;

